import React, { useMemo } from 'react';
import { CardHeader } from '@europrocurement/flexy-components';
import { Box, Typography, useTheme } from '@mui/material';

export type RequiredDocumentsHeadingProps = {
    currentCount: number;
    totalCount: number;
};

const RequiredDocumentsHeading: React.FunctionComponent<RequiredDocumentsHeadingProps> = function (
    props,
) {
    const { currentCount, totalCount } = props;
    const { palette } = useTheme();

    const color = useMemo(() => {
        if (totalCount > 0 && totalCount === currentCount) {
            return palette.success.main;
        }
        if (totalCount > 0 && currentCount > 0) {
            return palette.warning.main;
        }
        if (totalCount > 0 && currentCount === 0) {
            return palette.error.main;
        }
        return 'text.gris50';
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCount, totalCount]);

    return (
        <CardHeader
            title="Documents requis"
            titleSx={{
                fontSize: '20px',
                lineHeight: '28px',
            }}
            border={false}
            headerSx={{
                paddingX: '32px',
                paddingBottom: '1em',
            }}
            sx={{
                paddingX: 0,
            }}
            childrenSx={{ paddingX: 0 }}
        >
            <Box>
                {totalCount > 0 && (
                    <Typography
                        component="p"
                        variant="l2dbodyxs"
                        sx={{ color }}
                    >
                        {currentCount}/{totalCount} documents
                    </Typography>
                )}
                <Typography
                    component="p"
                    variant="l2dbodyxs"
                    sx={{ marginY: '8px', color: 'text.gris50' }}
                >
                    Formats : .pdf .doc .jpg .xls - Poids maximum : 10Mo
                </Typography>
            </Box>
        </CardHeader>
    );
};

export default RequiredDocumentsHeading;
